import wayAdd2 from '@/assets/image_message_appear/wayAdd@2x.png'
import wayError2 from '@/assets/image_message_appear/wayError@2x.png'
// import poiAdd2 from '@/assets/image_message_appear/poiAdd@2x.png'
import notPass from '@/assets/image_message_appear/notPass@3x.png'
import pass from '@/assets/image_message_appear/pass@3x.png'
import reviewing from '@/assets/image_message_appear/reviewing@3x.png'
import appearWayError from '@/assets/image_message_appear/appearWayError@2x.png'
import appearPoiAdd from '@/assets/image_message_appear/appearPoiAdd@2x.png'
import appearWayAdd from '@/assets/image_message_appear/appearWayAdd@2x.png'
import mapImg from '@/assets/image_message_appear/mapBanner.png'
import mapImgCheck from '@/assets/image_message_appear/mapImgCheck.png'
import mapImgSelected from '@/assets/image_message_appear/mapImgSelected.png'
import ipt_reset from '@/assets/image_message_appear/ipt_reset.png'
import type_jiantou from '@/assets/image_message_appear/type_jiantou.png'
import main from '../assets/image_message_appear/main.png'
import camera from '@/assets/image_message_appear/camera.png'
import shili from '@/assets/image_message_appear/shili.jpg'
import pageType1 from '@/assets/image_message_appear/pageType1.png'
import pageType2 from '@/assets/image_message_appear/pageType2.png'
import pageType3 from '@/assets/image_message_appear/pageType3.png'
import listpageType1 from '@/assets/image_message_appear/listpageType1.png'
import listpageType2 from '@/assets/image_message_appear/listpageType2.png'
import listpageType3 from '@/assets/image_message_appear/listpageType3.png'
import listpageType4 from '@/assets/image_message_appear/listpageType4.png'
import listpageType8 from '@/assets/image_message_appear/listpageType8.png'
import locationAdd from '@/assets/image_message_appear/locationAdd.png'
import ic_stop from '@/assets/image_message_appear/ic_stop.png'
import locationPics from '@/assets/image_message_appear/locationPics.png'
import locationVideo from '@/assets/image_message_appear/locationVideo.jpg'
import businessTimeAndPhonePic from '@/assets/image_message_appear/businessTimeAndPhonePic.png'
import batchReportIcon from '@/assets/image_message_appear/batchReportIcon.png'
import businessTimeAdd from '@/assets/image_message_appear/addx3.png'
import businessTimeDel from '@/assets/image_message_appear/delx3.png'

// 首页标签
const message_appear_type_lists = [
    {
        index: 0,
        title: '道路新增',
        isLink: true,
        hasIcon: true,
        icon: wayAdd2,
        className: 'wayAdd messageTypeLists'
    },
    // {
    //     index: 1,
    //     title: '道路报错',
    //     isLink: true,
    //     hasIcon: true,
    //     icon: wayError2,
    //     className: 'wayError messageTypeLists'
    // },
    {
        index: 2,
        title: '地点上报',
        isLink: true,
        hasIcon: true,
        icon: locationAdd,
        className: 'poiAdd messageTypeLists'
    },
]
// 首页标签 h5
const message_appear_type_listsh5 = [
    {
        index: 0,
        title: '道路新增',
        isLink: true,
        hasIcon: true,
        icon: wayAdd2,
        className: 'wayAdd messageTypeLists'
    },
    {
        index: 1,
        title: '道路报错',
        isLink: true,
        hasIcon: true,
        icon: wayError2,
        className: 'wayError messageTypeLists'
    },
    {
        index: 2,
        title: '地点上报',
        isLink: true,
        hasIcon: true,
        icon: locationAdd,
        className: 'poiAdd messageTypeLists'
    },
]
// 内部用户的查看
const staff_config = [
    {
        label: '快捷上报(鹅民专属)',
        title: '1个视频轻松反馈',
        value: '4',
        icon: batchReportIcon,
        className: 'wayAdd messageTypeLists',
    },
]
// 地点新增
const newAddLocationList = [
    {
        label: '地点新增',
        title: '发现新地点',
        value: '1',
        icon: pageType1,
        className: 'wayAdd messageTypeLists',
        userSelectLatLngTitle: '确认地点所在位置',
        select: false, // 快捷上报使用--是否选择
    },
    {
        label: '地点不存在',
        title: '地点搬迁、关闭',
        value: '2',
        icon: pageType2,
        className: 'wayError messageTypeLists',
        userSelectLatLngTitle: '',
        select: false, // 快捷上报使用--是否选择
    },
    {
        label: '地点信息更改',
        title: '坐标、营业时间等更正',
        value: '3',
        icon: pageType3,
        className: 'poiAdd messageTypeLists',
        userSelectLatLngTitle: '请选择新地点所在的位置',
        select: false, // 快捷上报使用--是否选择
    },
]
// 地点下线原因
const locationDownLine = [
    {
        label: '已搬迁',
        value: '1',
        select: false,
    },
    {
        label: '已关闭',
        value: '2',
        select: false,
    },
    {
        label: '不存在',
        value: '3',
        select: false,
    },
]
// 地点上报-营业日期
const columns = [
    { 
        text: '周一', 
        value: '1',
        select: false,
    },
    { 
        text: '周二', 
        value: '2',
        select: false,
    },
    { 
        text: '周三', 
        value: '3',
        select: false,
    },
    { 
        text: '周四', 
        value: '4',
        select: false,
    },
    { 
        text: '周五', 
        value: '5',
        select: false,
    },
    { 
        text: '周六', 
        value: '6',
        select: false,
    },
    { 
        text: '周日', 
        value: '7',
        select: false,
    },
]

const reviewStateImgLists= new Map([
    [40, reviewing],
    [41, reviewing],
    [42, reviewing],
    [50, pass],
    [60, notPass],
    [70, pass],
])

const reviewStateLists = new Map([
    [40, '审核中'],
    [41, '审核中'],
    [42, '审核中'],
    [50, '已通过'],
    [60, '未通过'],
    [70, '已支付'],
])
// 银河审核结论
const radioSelect = [
    {
        key: '0',
        value: '无',
    },
    {
        key: '7',
        value: '拍摄距离超过30米',
    },
    {
        key: '6',
        value: '少拍关系照',
    },
    {
        key: '11',
        value: '未进入室内拍摄',
    },
    {
        key: '3',
        value: '夜间拍摄',
    },
    {
        key: '1',
        value: '角度不合格',
    },
    {
        key: '9',
        value: '其他',
    },
    {
        key: '15',
        value: '图像画质模糊',
    },
    {
        key: '16',
        value: '告示文字模糊',
    },
    {
        key: '17',
        value: '店铺招牌/主体遮挡',
    },
    {
        key: '5',
        value: '乱拍',
    },
    {
        key: '10',
        value: '图片与描述不符',
    },
]
const subheadTrans = new Map([
    [1, '道路新增'],
    [2, '道路报错'],
    // [3, '地点新增'],
    [4, '地点新增'],
    [5, '地点不存在'],
    [6, '地点信息更改'],
    [7, '快捷上报'],
    [8, '车信上报'],
])
const subheadTransImg = new Map([
    [1, appearWayAdd],
    [2, appearWayError],
    [3, appearPoiAdd],
    [4, listpageType1],
    [5, listpageType2],
    [6, listpageType3],
    [7, listpageType4],
    [8, listpageType8],
])

// 道路新增--类型选择
const wayTypeSelect = [
    {
        label: '高速',
        value: 0,
        type: 'highSpeed'
    },
    {
        label: '城快',
        value: 1,
        type: 'cityRoad'
    },
    {
        label: '国道',
        value: 2,
        type: 'nationalRoad'
    },
    {
        label: '隧道',
        value: 3,
        type: 'tunnel'
    },
    {
        label: '桥梁',
        value: 4,
        type: 'bridge'
    },
    {
        label: '其他道路',
        value: 5,
        type: 'otherRoad'
    },
]

// 道路新增子标题 -- 顺序做了调整
const wayDetail = [
    {
        index: 0,
        title: '1.道路名称'
    },
    {
        index: 1,
        title: '2.类型选择'
    },
    {
        index: 2,
        title: '3.确认新增道路所在位置'
    },
    {
        index: 4,
        title: '4. 提供证明图片',
        type: '新增',
    },
    {
        index: 3,
        title: '5.新增道路信息描述',
        type: '新增',
    },
    {
        index: 5,
        title: '6. 信息来源链接'
    },
    {
        index: 6,
        title: '备注'
    },
]

// 道路报错子标题
const wayCorrection = [
    {
        index: '道路报错-1',
        title: '1.道路名称'
    },
    {
        index: '道路报错-2',
        title: '2.道路通行状态'
    },
    {
        index: 2,
        title: '3.确认报错道路所在位置'
    },
    {
        index: 3,
        title: '4.报错道路信息描述',
        type: '报错',
    },
    {
        index: 4,
        title: '5. 提供证明图片',
        type: '报错',
    },
    {
        index: 5,
        title: '6. 信息来源链接'
    },
    {
        index: 6,
        title: '备注'
    },
]

// 地点新增子标题
const poiDetail = [
    {
        index: '地点新增-1',
        title: '1.地点名称'
    },
    {
        index: 2,
        title: '2.确认新增地点所在位置',
    },
    {
        index: '地点新增-2',
        title: '3. 提供证明图片'
    },
    {
        index: 6,
        title: '备注'
    },
]

export {
    notPass,
    pass,
    reviewing,
    mapImg,
    mapImgSelected,
    mapImgCheck,
    ipt_reset,
    type_jiantou,
    main,
    message_appear_type_lists,
    staff_config,
    wayDetail,
    subheadTrans,
    reviewStateLists,
    subheadTransImg,
    reviewStateImgLists,
    wayCorrection,
    poiDetail,
    newAddLocationList,
    camera,
    shili,
    locationDownLine,
    columns,
    ic_stop,
    businessTimeAndPhonePic,
    locationPics,
    locationVideo,
    businessTimeAdd,
    businessTimeDel,
    radioSelect,
    wayTypeSelect,
    message_appear_type_listsh5,
}
